export default [
  'attn.tv',
  'google-analytics.com',
  'segment.com',
  'zdassets.com',
  'segment.io',
  'mixpanel.com',
  'clickagy.com',
  'satismeter.com',
  'zoominfo.com',
  'doubleclick.net',
  'stonly.com',
  'myfeelback.com',
  'crbug.com',
]
